import * as BABYLON from "babylonjs";
import "babylonjs-loaders/babylonjs.loaders.min.js";
export function addRoads() {
  // setTimeout(() => {
    var roadmaterial = new window.BABYLON.StandardMaterial(
      "road",
      levelsShowIns.scene
    );
    var roadmaterialpt = new window.BABYLON.RoadProceduralTexture(
      "customtext",
      512,
      levelsShowIns.scene
    );
    var roadmaterialpt2 = new BABYLON.Texture("/static/webgl/road.png");
    roadmaterial.diffuseTexture = roadmaterialpt2;
    roadmaterial.specularColor = new BABYLON.Color3(0.3, 0.3, 0.3);
    roadmaterial.specularPower = 0;
    var plane = window.BABYLON.Mesh.CreatePlane(
      "road1",
      2,
      levelsShowIns.scene
    );
    plane.rotation.x = Math.PI / 2;
    plane.rotation.y = Math.PI / 2;
    plane.position.y = 0.1;
    plane.material = roadmaterial;
    for (let index = 0; index < 10; index++) {
      let newPlane = plane.clone();
      newPlane.position.z = 0.2 + index * 0.2;
      let newPlane2 = plane.clone();
      newPlane2.position.z = -0.2 - index * 0.2;
    }
  // }, 0);
}
export function addGrass(self) {
  // const ground = BABYLON.MeshBuilder.CreateGround("ground", {
  //   width: 1000,
  //   height: 1000
  // });
  const ground = BABYLON.MeshBuilder.CreateDisc("ground", {radius: 600, arc: 1, tessellation: 360, sideOrientation: BABYLON.Mesh.DOUBLESIDE}, self.scene);
  ground.rotation.x = Math.PI / 2
  ground.receiveShadows = true;



  let groundMat = new BABYLON.PBRMaterial("groundMat", self.scene);
  groundMat.metallic = 0;
  groundMat.roughness = 1;
  // mat.disableLighting = true
  groundMat.subSurface.isTranslucencyEnabled = true;
  groundMat.albedoTexture = new BABYLON.Texture("/static/webgl/grass4.png");
  groundMat.albedoTexture.hasAlpha = true;
  groundMat.albedoTexture.uScale = 50.0;
  groundMat.albedoTexture.vScale = 50.0;

  // const groundMat = new BABYLON.StandardMaterial("groundMat");
  // groundMat.specularColor = new BABYLON.Color3(0.3, 0.3, 0.3);
  // groundMat.specularPower = 0;
  // groundMat.metallic = 0;
  // groundMat.roughness = 0.9;
  // groundMat.emissiveColor = new BABYLON.Color3(0.8, 0.8, 0.8);
  // // let png = 'https://dl.polyhaven.org/file/ph-assets/Textures/jpg/4k/aerial_grass_rock/aerial_grass_rock_diff_4k.jpg'
  // // groundMat.diffuseTexture = new BABYLON.Texture(png);
  // groundMat.diffuseTexture = new BABYLON.Texture("/static/webgl/grass4.png");
  // // groundMat.diffuseTexture = new BABYLON.Texture("/static/webgl/grass2_D.jpg");
  // // groundMat.bumpTexture = new BABYLON.Texture("/static/webgl/grass_N.jpg");
  // // groundMat.bumpTexture.uScale = 60.0;
  // // groundMat.bumpTexture.vScale = 60.0;
  // groundMat.diffuseTexture.hasAlpha = true;
  // groundMat.diffuseTexture.uScale = 50.0;
  // groundMat.diffuseTexture.vScale = 50.0;


  ground.material = groundMat;
}

export function addSky(self) {
  // self.loader.loadhdrenv("/static/webgl/sunflowers_2k.hdr", self.scene);
  // self.loader.loadhdrenv("/static/webgl/3.hdr", self.scene);
  self.loader.loadenv("/static/webgl/1.env", self.scene);
  // self.loader.loadenv("/static/webgl/2.env", self.scene);
  let scene = self.scene;
  const skybox = BABYLON.MeshBuilder.CreateBox("skyBox", { size: 1000 }, scene);
  skybox.applyFog = false
  const skyboxMaterial = new BABYLON.StandardMaterial("skyBox", scene);
  skyboxMaterial.backFaceCulling = false;
  // let texture = new BABYLON.CubeTexture(
  //   "https://www.babylonjs-playground.com/textures/TropicalSunnyDay",
  //   scene
  // );
  let texture = new BABYLON.CubeTexture(
    "/static/webgl/sky/sky",
    scene
  );
  // scene.environmentTexture = texture;
  skyboxMaterial.reflectionTexture = texture
  skyboxMaterial.reflectionTexture.coordinatesMode =
    BABYLON.Texture.SKYBOX_MODE;
  skyboxMaterial.diffuseColor = new BABYLON.Color3(0, 0, 0);
  skyboxMaterial.specularColor = new BABYLON.Color3(0, 0, 0);
  skybox.material = skyboxMaterial;
}

export function addScene(self) {
  let xyz = 0.12
  let containerMain = self.loader.cache["scene.glb"];
  containerMain.meshes[0].scaling.x = xyz;
  containerMain.meshes[0].scaling.y = xyz;
  containerMain.meshes[0].scaling.z = xyz;
  containerMain.meshes[2].visibility = 0;
  containerMain.addAllToScene();
}

export function addPoiLight(self){
  let  scene = self.scene
  var light1 = new BABYLON.HemisphericLight("light1", new BABYLON.Vector3(0.3, 1, 0.3),scene); //半球
  light1.intensity = 0.4
  var light = new BABYLON.DirectionalLight("DirectionalLight", new BABYLON.Vector3(0, -1, -1), scene);
  light.position.z = 150
  light.intensity = 1.30
  // var light = new BABYLON.SpotLight(
  //   "spot00",
  //   new BABYLON.Vector3(0, 20, 20),
  //   new BABYLON.Vector3(0, -1, -1),
  //   1.2,
  //   24,
  //   scene
  // );
  light.shadowMinZ = 15;
  light.shadowMaxZ = 4000;

  var shadowGenerator = new BABYLON.ShadowGenerator(512, light);
  var renderList = shadowGenerator.getShadowMap().renderList
  shadowGenerator.useContactHardeningShadow = true;
  shadowGenerator.contactHardeningLightSizeUVRatio = 0.0075;
  return {
    light,
    renderList,
    shadowGenerator,
  }
}



// WEBPACK FOOTER //
// ./src/components/webgl/LevelsShow/Object/Env.js